<template>
  <div class="park-over-view">
    <div class="park-over-view-line" style="padding: 30px 0;align-items: center">
      <div class="park-over-view-line-box1" style="background:linear-gradient(#2EA2F9, #2EA2F999);">
        <div class="park-over-view-line-box-item">
          <div class="park-over-view-line-box-item-num">{{parkingPlace.parkingPlaceTotalNumber || 0}}</div>
          <div class="park-over-view-line-box-item-tip">车位总数<i class="el-icon-edit" style="margin-left: 5px;font-size: 18px;cursor: pointer;" @click="changeParkingPlaceVisible = true"></i></div>
        </div>
        <div class="park-over-view-line-box-item">
          <div class="park-over-view-line-box-item-num">{{parkingPlace.parkingPlaceLeftNumber || 0}}</div>
          <div class="park-over-view-line-box-item-tip">空余车位数</div>
        </div>
        <div class="park-over-view-line-box-item">
          <div class="park-over-view-line-box-item-num">{{parkingPlace.parkingPlacePresentNumber || 0}}</div>
          <div class="park-over-view-line-box-item-tip">在场车辆数</div>
        </div>
        <div class="park-over-view-line-box-item">
          <div class="park-over-view-line-box-item-num">{{parkingPlace.saturability || 0}}</div>
          <div class="park-over-view-line-box-item-tip">饱和度</div>
        </div>
      </div>

      <div class="park-over-view-line-box2" style="background:linear-gradient(#FFB53E, #FFB53E99);">
        <div class="park-over-view-line-box-item">
          <el-popover
            placement="top"
            title=""
            width="200"
            trigger="hover"
            content="">
            <p style="text-align: center">进场：{{parkingDayData.carInNumber || 0}}辆</p>
            <p style="text-align: center">出场：{{parkingDayData.carOutNumber || 0}}辆</p>
            <div class="park-over-view-line-box-item-num" style="cursor: pointer;" slot="reference">{{parkingDayData.carInAndOutNumber || 0}}</div>
          </el-popover>
          <div class="park-over-view-line-box-item-tip">今日车流量</div>
        </div>
        <div class="park-over-view-line-box-item">
          <el-popover
            placement="top"
            title=""
            width="200"
            trigger="hover"
            content="">
            <p style="text-align: center">包月：{{parkingDayData.monthMoney || 0}}元</p>
            <p style="text-align: center">临停：{{parkingDayData.tempMoney || 0}}元</p>
            <div class="park-over-view-line-box-item-num" style="cursor: pointer;" slot="reference">{{parkingDayData.totalMoney || 0}}</div>
          </el-popover>
          <div class="park-over-view-line-box-item-tip">今日实收金额</div>
        </div>
        <div class="park-over-view-line-box-item">
          <el-popover
            placement="top"
            title=""
            width="200"
            trigger="hover"
            content="">
            <p style="text-align: center">包月：{{parkingDayData.monthNumber || 0}}笔</p>
            <p style="text-align: center">临停：{{parkingDayData.tempNumber || 0}}笔</p>
            <div class="park-over-view-line-box-item-num" style="cursor: pointer;" slot="reference">{{parkingDayData.totalNumber || 0}}</div>
          </el-popover>
          <div class="park-over-view-line-box-item-tip">今日支付笔数</div>
        </div>
      </div>

      <div class="park-over-view-line-box3" style="background:linear-gradient(#67C23A, #67C23A99);">
        <div class="park-over-view-line-box-item">
          <div class="park-over-view-line-box-item-num"><span style="color: red">{{deviceInfo.offlineDeviceCount || 0}}</span>/{{deviceInfo.totalDeviceCount || 0}}</div>
          <div class="park-over-view-line-box-item-tip">离线数/设备总数</div>
        </div>
        <div class="park-over-view-line-box-item">
          <div class="park-over-view-line-item-title" style="cursor: pointer;margin-bottom: 5px;">临停车开票码</div>
          <div id="createCodeTempBox">
            <canvas class="qrcode" ref="qrCodeTempUrl" id="createTempCode"></canvas>
          </div>
        </div>
        <div class="park-over-view-line-box-item">
          <div class="park-over-view-line-item-title" style="cursor: pointer;margin-bottom: 5px;">提前缴费收款码</div>
          <div id="createCodeBox">
            <canvas class="qrcode" ref="qrCodeUrl" id="createCode"></canvas>
          </div>
        </div>
      </div>
    </div>



    <div class="finance-over-view-line" style="height: 280px;margin: 20px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">
      <common-stacking-bar barIdName="parkingCarAccessRecordBar" :height='"260px"' barTitle="今日车流" :colorList="['#2EA2F9', '#67C23A']" :legendData="parkingCarAccessRecordLegendData" :xAxis="parkingCarAccessRecordXAxis" :yAxis='parkingCarAccessRecordYAxis' :series='parkingCarAccessRecordSeries'/>
    </div>

    <div class="finance-over-view-line" style="height: 280px;margin: 20px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">
      <common-stacking-bar barIdName="parkingCarAmountBar" :height='"260px"' barTitle="今日收款" :colorList="['#2EA2F9', '#67C23A']" :legendData="parkingCarAmountLegendData" :xAxis="parkingCarAmountXAxis" :yAxis='parkingCarAmountYAxis' :series='parkingCarAmountSeries'/>
    </div>

    <div class="finance-over-view-line" style="height: 280px;margin: 20px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">
      <chart-time-select @getData="getParkingTrafficStatisticsOverview" />
      <common-line style="z-index: 1000" lineId='parkingTrafficStatisticsLine' :height='"260px"' lineTitle='流量统计' :legendData="parkingTrafficStatisticsLegendData" :xAxis="parkingTrafficStatisticsXAxis" :yAxis='parkingTrafficStatisticsYAxis' :series='parkingTrafficStatisticsSeries' />
    </div>

    <div class="finance-over-view-line" style="height: 280px;margin: 20px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">
      <chart-time-select @getData="getParkingChargeStatisticsOverview" />
      <common-line style="z-index: 1000" lineId='parkingChargeStatisticsLine' :height='"260px"' lineTitle='收费统计' :legendData="parkingChargeStatisticsLegendData" :xAxis="parkingChargeStatisticsXAxis" :yAxis='parkingChargeStatisticsYAxis' :series='parkingChargeStatisticsSeries' />
    </div>

    <el-dialog title="车场信息" :visible.sync="changeParkingPlaceVisible" width="500px">
      <el-form style="width: 360px;margin: 0 auto;">
        <el-form-item label="车位数量" label-width="120px">
          <el-input v-model="parkingPlace.parkingPlaceTotalNumber" autocomplete="off" size="small" style="width: 220px;" />
        </el-form-item>
        <el-form-item label="空余车位数量" label-width="120px">
          <el-input v-model="parkingPlace.parkingPlaceLeftNumber" autocomplete="off" size="small" style="width: 220px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelChangeParkingPlace" size="small">取 消</el-button>
        <el-button type="primary" @click="changeParkingPlace" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import CommonRing from '../../../components/Echarts/Pie/Pie/commonRing'
  import {api} from '../../api/ParkingService'
  import {errorHandler} from '../../../utils/errorHandler'
  import CommonLine from '../../../components/Echarts/Line/commonLine'
  import {nError, nSuccess} from '../../../utils/notice'
  import html2canvas from "html2canvas";
  import QrCodeWithLogo from "qr-code-with-logo";
  import {bus} from '../../../utils/bus'
  import CommonStackingBar from "../../../components/Echarts/Bar/commonStackingBar";
  import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";

  export default {
    components: {
      ChartTimeSelect,
      CommonStackingBar,
      CommonLine,
      CommonRing},
    name: 'park-over-view',
    data () {
      return {
        onlineColorList: ['#44c23b', '#f54659'],
        parkingPlaceColorList: ['#00A0E6', '#dddddd'],
        commonRingLegend: {
          left: 'center',
          bottom: -5,
        },
        onlineTitle: '设备状态',
        onlineInfo: [],
        deviceInfo: {},
        parkingPlace: {},
        parkingPlaceInfo: [],

        parkingDayData: {},

        carAccessCount: 0,
        totalMoney: 0,


        parkingCarAccessRecordRadio: false,
        parkingCarAccessRecordLegendData: ['进场', '出场'],
        parkingCarAccessRecordXAxis: {
          type: 'category',
          name: '时间',
          data: []
        },
        parkingCarAccessRecordYAxis: [
          {
            type: 'value',
            name: '次',
            splitLine: {
              show: false
            },
          }
        ],
        parkingCarAccessRecordSeries: [],

        parkingCarAmountLegendData: [],
        parkingCarAmountXAxis: {
          type: 'category',
          name: '时间',
          data: []
        },
        parkingCarAmountYAxis: [
          {
            type: 'value',
            name: '金额',
            splitLine: {
              show: false
            },
          }
        ],
        parkingCarAmountSeries: ['临停收费', '包月收费'],

        parkingConsumptionRecordRadio: false,
        parkingConsumptionRecordLegendData: ['进场数', '出场数'],
        parkingConsumptionRecordXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        parkingConsumptionRecordYAxis: [
          {
            type: 'value',
            name: '金额',
            splitLine: {
              show: false
            },
          }
        ],
        parkingConsumptionRecordSeries: [],

        changeParkingPlaceVisible: false,

        parkingTrafficStatisticsRadio: 'DAY',
        parkingTrafficStatisticsTimeValue: [],
        parkingTrafficStatisticsXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        parkingTrafficStatisticsYAxis: [
          {
            type: 'value',
            name: '辆',
            splitLine: {
              show: false
            },
          }
        ],
        parkingTrafficStatisticsLegendData: ['进场数', '出场数'],
        parkingTrafficStatisticsSeries: [],

        parkingChargeStatisticsRadio: 'DAY',
        parkingChargeStatisticsTimeValue: [],
        parkingChargeStatisticsXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        parkingChargeStatisticsYAxis: [
          {
            type: 'value',
            name: '元',
            splitLine: {
              show: false
            },
          }
        ],
        parkingChargeStatisticsLegendData: ['临停收费', '包月收费'],
        parkingChargeStatisticsSeries: [],
      }
    },
    created () {
      this.getCreateTime()
    },
    mounted () {
      this.getCodes()
      this.getTempCodes()
      this.getParkingPlaceLeftNumber()
      this.getParkingDayOverview()
      this.getParkingDeviceOverview()
      this.getParkingDayStaticticsOverview()
      this.getParkingDayAmountStaticticsOverview()
    },
    methods: {
      getCreateTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        this.parkingTrafficStatisticsTimeValue[0] = year + '-' + month + '-01'
        this.parkingTrafficStatisticsTimeValue[1] = year + '-' + month + '-' + date
        this.parkingChargeStatisticsTimeValue[0] = year + '-' + month + '-01'
        this.parkingChargeStatisticsTimeValue[1] = year + '-' + month + '-' + date
      },
      // 获取车场数据
      getParkingPlaceLeftNumber () {
        this.$axios.get(api.getParkingPlaceOverview, {})
          .then(res => {
            let data = res.data.data
            this.parkingPlace = data
          })
          .catch(errorHandler('获取车位信息失败'))
      },
      // 获取今日车场数据
      getParkingDayOverview () {
        this.$axios.get(api.getParkingDayOverview, {})
          .then(res => {
            let data = res.data.data
            this.parkingDayData = data
          })
          .catch(errorHandler('获取今日数据失败'))
      },

      // 取消修改车场信息
      cancelChangeParkingPlace () {
        this.getParkingPlaceLeftNumber()
        this.changeParkingPlaceVisible = false
      },

      // 修改车场信息
      changeParkingPlace () {
        if (!this.parkingPlace.parkingPlaceTotalNumber) {
          nError('请输入车位数量')
          return false
        }
        // if (!this.parkingPlace.parkingPlacePresentNumber) {
        //   nError('请输入空余车位数量')
        //   return false
        // }
        // if (+this.parkingPlace.parkingPlaceTotalNumber < +this.parkingPlace.parkingPlacePresentNumber) {
        //   nError('车位数量不能小于空余车位数量')
        //   return false
        // }
        this.$axios.post(api.updateParkingPlace, this.parkingPlace)
          .then(res => {
            nSuccess('修改成功')
            this.changeParkingPlaceVisible = false
            this.getParkingPlaceLeftNumber()
          })
          .catch(errorHandler('修改失败'))
      },

      getParkingDeviceOverview () {
        this.$axios.get(api.getParkingDeviceOverview, {})
          .then(res => {
            let data = res.data.data
            this.deviceInfo = data
            this.onlineInfo = [
              {name: '在线', value: data.onlineDeviceCount },
              {name: '离线', value: data.offlineDeviceCount }
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

      // geParkingOtherOverview () {
      //   this.$axios.get(api.geParkingOtherOverview, {})
      //     .then(res => {
      //       let data = res.data.data
      //       this.carAccessCount = data.carAccessCount
      //       this.totalMoney = data.totalMoney
      //     })
      //     .catch(errorHandler('获取数据失败'))
      // },

      // 当日车流统计
      getParkingDayStaticticsOverview () {
        this.$axios.get(`${api.getParkingDayStaticticsOverview}`, {})
          .then(res => {
            let data = res.data.data
            let xData = []
            let carInNumberSeriesData = [], carOutNumberSeriesData = []
            data.map(v => {
              carInNumberSeriesData.push(v.carInNumber.toString())
              carOutNumberSeriesData.push(v.carOutNumber.toString())
              xData.push(v.time)
            })
            this.parkingCarAccessRecordXAxis.data = xData
            this.parkingCarAccessRecordSeries = [
              {
                name: '进场',
                type: 'bar',
                label: {
                  normal: {
                    show: true
                  }
                },
                data: carInNumberSeriesData
              },
              {
                name: '出场',
                type: 'bar',
                label: {
                  normal: {
                    show: true
                  }
                },
                data: carOutNumberSeriesData
              },
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

      // 当日金额统计
      getParkingDayAmountStaticticsOverview () {
        this.$axios.get(`${api.getParkingDayStaticticsOverview}`, {})
          .then(res => {
            let data = res.data.data
            let xData = []
            let tempMoneySeriesData = [], monthMoneySeriesData = []
            data.map(v => {
              tempMoneySeriesData.push(v.temporaryStopMoney.toString())
              monthMoneySeriesData.push(v.monthlyStopMoney.toString())
              xData.push(v.time)
            })
            this.parkingCarAmountXAxis.data = xData
            this.parkingCarAmountSeries = [
              {
                name: '临停收费',
                type: 'bar',
                stack: '总量',
                label: {
                  normal: {
                    show: true
                  }
                },
                data: tempMoneySeriesData
              },
              {
                name: '包月收费',
                type: 'bar',
                stack: '总量',
                label: {
                  normal: {
                    show: true
                  }
                },
                data: monthMoneySeriesData
              },
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

      // 流量统计
      getParkingTrafficStatisticsOverview (type, startTime, endTime) {
        this.$axios.post(`${api.getParkingTrafficStaticticsOverview}`, {
          timeType: type || 'DAY',
          startTime: startTime,
          endTime: endTime,
        })
          .then(res => {
			      let data = res.data.data
            let xData = [], carInNumberSeriesData = [], carOutNumberSeriesData = []
            data.map(v => {
              carInNumberSeriesData.push(v.carInNumber.toString())
              carOutNumberSeriesData.push(v.carOutNumber.toString())
              xData.push(v.time)
            })
            this.parkingTrafficStatisticsXAxis.data = xData
            this.parkingTrafficStatisticsSeries = [
              {
                name: '进场数',
                type: 'line',
                stack: '进场数',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: carInNumberSeriesData
              },
              {
                name: '出场数',
                type: 'line',
                stack: '出场数',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#4BB66E'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4BB66E'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: carOutNumberSeriesData
              }
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

      // 收费统计
      getParkingChargeStatisticsOverview (type, startTime, endTime) {
        this.$axios.post(`${api.getParkingTrafficStaticticsOverview}`, {
          timeType: type || 'DAY',
          startTime: startTime,
          endTime: endTime,
        })
          .then(res => {
            let data = res.data.data
            let xData = [], monthlyStopMoneySeriesData = [], temporaryStopMoneySeriesData = []
            data.map(v => {
              monthlyStopMoneySeriesData.push(v.monthlyStopMoney.toString())
              temporaryStopMoneySeriesData.push(v.temporaryStopMoney.toString())
              xData.push(v.time)
            })
            this.parkingChargeStatisticsXAxis.data = xData
            this.parkingChargeStatisticsSeries = [
              {
                name: '包月收费',
                type: 'line',
                stack: '总量',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: monthlyStopMoneySeriesData
              },
              {
                name: '临停收费',
                type: 'line',
                stack: '总量',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#4BB66E'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#4BB66E'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: temporaryStopMoneySeriesData
              }
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

      getCodes () {
        setTimeout(() => {
          QrCodeWithLogo.toCanvas({
            canvas: document.getElementById('createCode'),
            content: `https://yq.damaiiot.com/gyH5Index.html#/advancePayment/${bus.global.yqCode}`,
            width: 800,
          })
            .catch()
        }, 100)
      },
      setImage () {
        let that = this
        html2canvas(this.$refs.qrCodeUrl).then(canvas => {
          console.log(canvas.style)
          let image = canvas.toDataURL("image/jpeg")
          console.log(image)
          let $a = document.createElement('a')
          $a.setAttribute('href', image)
          $a.setAttribute('download', '临停二维码')
          $a.click()
        })
      },
      getTempCodes () {
        setTimeout(() => {
          QrCodeWithLogo.toCanvas({
            canvas: document.getElementById('createTempCode'),
            content: `https://yq.damaiiot.com/gyH5Index.html#/dmInvoiceLogin/${bus.global.yqCode}`,
            width: 800,
          })
            .catch()
        }, 100)
      },
    },
    watch: {}

  }
</script>


<style lang="less">
  .park-over-view {
    padding: 10px 2%;
    .park-over-view-line {
      display: flex;
      justify-content: space-between;

      .park-over-view-line-box1 {
        width: 33%;
        height: 170px;
        color: #FFFFFF;
        //background-color: #2EA2F9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border-radius: 5px;
      }
      .park-over-view-line-box2 {
        width: 33%;
        height: 170px;
        color: #FFFFFF;
        //background-color: #FFB53E;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 10px;
        border-radius: 5px;
      }
      .park-over-view-line-box3 {
        width: 33%;
        height: 170px;
        color: #FFFFFF;
        //background-color: #67C23A;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 10px;
        border-radius: 5px;
      }
      .park-over-view-line-box-item {
        width: 33%;
        .park-over-view-line-box-item-num {
          font-size: 42px;
          height: 80px;
          line-height: 80px;
        }
      }
      #createCodeBox {
        width: 100px;
        height: 100px;
        border-radius: 5px;
        margin: 0 auto;
      }
      #createCodeBox canvas {
        width: 100px!important;
        height: 100px!important;
        border-radius: 5px;
      }

      .park-over-view-line-item {
        width: 24%;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        padding: 10px 20px;
        position: relative;
        height: 262px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .park-over-view-line-item-title {
          font-size: 20px;
          font-weight: 600;
          text-align: center;
        }
        .park-over-view-line-item-info {
          flex: 1;
          padding: 20px 0 0 0;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          text-align: center;
          .park-over-view-line-item-info-line {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .park-over-view-line-item-info-line-num {
              font-size: 24px;
              font-weight: 700;
              margin-right: 10px;
            }
            .park-over-view-line-item-info-line-tip {
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }



      .park-person-count-box {
        width: 200px;
        height: 80px;
        padding: 10px 10px;
        border-radius: 10px;
        color: #ffffff;
        background-color: #00A0E6;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        margin: 20px auto;
        .park-person-count {
          font-size: 32px;
          font-weight: 500;
        }
        .park-person-tip {
          font-size: 14px;
        }
      }
      .park-over-view-line-left {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
      }
      .park-over-view-line-right {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        overflow: hidden;
      }

      .el-table {
        thead {
          th {
            padding: 6px 0;
            text-align: center;
            color: #666666;
            background-color: #eff1f5;
          }
        }
        tbody {
          td {
            padding: 6px 0;
            text-align: center;
            color: #FF0000;
          }
        }
      }

      .el-pagination {
        padding: 0;
      }
    }
  }
  #createCodeTempBox {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    margin: 0 auto;
  }
  #createCodeTempBox canvas {
    width: 100px!important;
    height: 100px!important;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkOverView/ParkOverView.vue